<template>
  <header class="header-wrapper">
    <div>
      <img class="left-img" src="@/assets/pro_scheduler.png" alt="" @click="goToHome" />
      <img class="right-img" src="@/assets/prometric_icon.png" alt="" v-if="isPhone" @click="goToOtherWeb" />
    </div>
    <div class="header-wrapper-right">
      <div class="lang-changer">
        <div class="lang-text">{{ $t('common.lang') }}</div>
        <el-select v-model="languageValue" @change="changeLanguage" placeholder="">
          <el-option v-for="item in languageOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div v-if="!isPhone"><img src="@/assets/prometric_icon.png" alt="" @click="goToOtherWeb" /></div>
    </div>
  </header>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MyHeader',
  data() {
    return {
      languageValue: '',
      languageOptions: [
        { value: 'zh-CN', label: '中文简体' },
        { value: 'en-US', label: 'English' },
      ],
      isPhone: false,
    }
  },
  computed: {
    ...mapGetters(['language']),
  },
  created() {
    this.languageValue = this.language
  },
  watch: {
    language: {
      handler(newVal) {
        this.languageValue = newVal
      },
      immediate: true,
    },
    MobileVerification: {
      handler(newVal) {
        this.isPhone = newVal
      },
      immediate: true,
    },
  },
  methods: {
    // 多语言切换
    changeLanguage(type) {
      this.languageValue = type
      this.$store.commit('app/SET_LANGUAGE', type)
    },
    goToHome() {
      if (sessionStorage.getItem('token') && !['/', '/homeIndex'].includes(this.$route.path)) {
        this.$router.replace('/homeIndex')
      }
    },
    goToOtherWeb() {
      window.location.href = 'https://www.prometric.com.cn/'
    },
  },
}
</script>
<style lang="less" scoped>
.header-wrapper {
  height: @header-height;
  padding: 0 16px;
  border-bottom: 3px solid @primary-color;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: @white-color;
  z-index: 99;
  .flex_arrange(row, space-between);
  & > div:nth-child(1) {
    .flex_arrange(row, space-between);
    .left-img {
      width: 156px;
      cursor: pointer;
    }
    .right-img {
      width: 156px;
      cursor: pointer;
    }
  }
  &-right {
    display: flex;
    .lang-changer {
      margin-left: 10px;
      .flex_arrange(row, space-between);
      .lang-text {
        font-size: 18px;
        margin-right: 8px;
      }
      /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
      }
      /deep/.el-select .el-input__inner:focus {
        border-color: #5f6164;
        outline: 3px solid #5f6164;
      }
      /deep/.el-input__icon {
        line-height: 30px;
      }
    }
    & > div:nth-child(2) {
      img {
        cursor: pointer;
        width: 185px;
        vertical-align: middle;
      }
    }
  }
}
.header-placeholder {
  height: @header-height;
}
@media (max-width: 840px) {
  .header-wrapper {
    height: @header-height-phone;
    flex-direction: column;
    & > div:nth-child(1) {
      width: 100%;
    }
    &-right {
      width: 100%;
      justify-content: flex-end;
      margin-bottom: 10px;
    }
  }
}
</style>
